<template>
    <div style="background:#FAFAFA" class="my-table-box">
      <div class="tableHead">
        <el-input
            placeholder="请输入内容"
            class="search"
            @keyup.enter.native="search"
            v-model="condition">
          <i slot="suffix" @click="search" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class="topRight">
          <el-button class="topBtn" @click="handlerBatchDowload" icon="el-icon-download" circle>批量下载</el-button>
          <el-dropdown class="topBtn" trigger="click" @command="handlerAdd">
          <span class="el-dropdown-link">
        <i class="el-icon-circle-plus"></i>&nbsp;新增
      </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(model,index) in modelTypeList"
                                :key="index"
                                :command="model"
              >{{model.modelType}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <el-table
          height="calc(100vh - 160px - 4.2rem - 10px - 42px - 50px)"
          :data="this.tableData||[]"
          align="center"
          @select="handlerSelect"
          @select-all="handlerSelect"
          :header-cell-style="{background:'#FAFAFA'}"
          :summary-method="handlerSum"
          :show-summary="false"
          :row-class-name="tableRowClassAdaptor"
          sum-text="选中合计"
      >
        <el-table-column
            type="selection"
            width="30"
        >
        </el-table-column>
        <el-table-column
            type="index"
            label="编号"
            header-align="center"
            align="center"
            :index="start+1"
            width="55">
        </el-table-column>
        <el-table-column
            v-for="(item,index) in columnSet"
            :key="Number(index+2)"
            align="center"
            :prop="item.columnName"
            :label="item.label"
            :width="item.with"
            :column-key="index+''"
            :sortable = "item.sortable"
            v-show="item.hidden"
        >
          <template slot-scope="scope">
              <div style="margin-left: -12px" v-if="label(scope)===0" v-html="getRowData(scope)"></div>
              <el-tag v-if="label(scope)===1">{{getRowData(scope)}}</el-tag>
              <el-tag type="success" v-if="label(scope)===2">{{getRowData(scope)}}</el-tag>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination
          align="right"
          style="padding:7px 4px"
          @current-change="pageChange"
          @size-change="handlerSizeChange"
          :current-page.sync="current"
          :page-sizes="[8, 25, 50, 100]"
          :page-size="limit"
          v-if="limit"
          layout="sizes, prev, pager, next,total"
          :total="count">
      </el-pagination>
    </div>
</template>
<style>
.el-table .success-row{
  background:#e1f7d5!important;
}
.el-table .warning-row{
  background:#f5cabc!important;
}
</style>

<script>
import {mapMutations} from "vuex";
import {Message} from "element-ui";
export default {
  name: "myTable",
  components: {
  },
  props:{
    limit:{
      type:Number,
      required: true
    },//限制条数
    count:{//总条数
      type:Number,
      default: 10,
      required:true
    },//总条数
    data:{
      type:Array,
      default:function () {
        return [];
      },
      required:true
    },//表数据
    columnSet:{
      type:Array,
      default:function () {
        return [
          {columnName:'orderNo',width:'180',label:'订单号',sortable:true},
          {columnName:'productType',width:'180',label:'产品类型',labelType:'blue'},
          {columnName:'productNo',width:'180',label:'产品型号',labelType:'green'},
          {columnName:'count',width:'180',label:'数量',sortable:true},
          {columnName:'price',width:'180',label:'单价',sortable:true},
          {columnName:'totalPrice',width:'180',label:'总价',sortable:true},
        ]
      }
    }//列设置
  },
  data() {
    return {
      checkedRow:[],//所有选中行
      condition:'',
      message:'',
      current:1,
      label0:{
        blue:[],
        green:[]
      },
      modelType:'',
      modelTypeList:[]
    }
  },
  methods:{
    handlerBatchDowload(){
      const ids = [];
      for (const row of this.checkedRow) {ids.push(row.id);}
      console.log(ids);
    },
    /**
     * 处理改变页大小的事件
     * @param val
     */
    handlerSizeChange(val){
      this.$emit('sizeChange',val);
    },
    /**
     * 处理新增模型的方法
     * @param model 模型对象，包含模型类型与模型图
     */
    handlerAdd(model){
      this.openAddModel(model);
    },
    openDialog(model){
      this.$store.commit('openAddModel',model);
    },
    search(){//条件查询事件
      console.log(this.condition);
    },
    pageChange(val){//分页组件点击触发，保存改变后的页码
      this.$emit('getPage',val);
      this.current = val;
    },
    handlerSelect(selection){//选中行时，将所有选中行保存
      this.checkedRow = selection;
    },
    handlerSum(){
      return ['','*',"选中总计：",'','','','',this.countPrice];
    },
    /**
     * 处理行数据与列数据的显示格式
     * @param scope
     * @returns {string|unknown}
     */
    getRowData(scope){
      const key = scope.column.columnKey;//当前列的key
      const rowData = Object.values(scope.row);
      let text = rowData[key];//获取当前一行的key列的数据
      const urlArr = text.split(';');
      if(key==='5'){//如果为【方案图】列，则根据出图结果不同展示不同的按钮或信息
        switch (text) {
          case '-1':
            text = '排队中';
            break;
          case '0':
            text = '出图中';
            break;
          default:
            if (urlArr.length===1){
              text = `<a href="http://${text}" target="_blank" >预览</a>&nbsp;
                <a href="http://${text}" target="_blank" download="${rowData[0]}">下载</a>`;
            }else {
              text = `<a href="http://${urlArr[0]}" target="_blank" >预览</a>&nbsp;
                <a href="http://${urlArr[0]}" target="_blank" download="${rowData[0]}">下载</a>&nbsp;
                <a href="http://${urlArr[1]}" target="_blank" download="${rowData[0]}">完整包</a>`;
            }
            break;
        }
      }
      return text;
    },
    tableRowClassAdaptor(row){
      if (row.row.drawing==='-1'){
        return 'warning-row';
      }else if(row.row.drawing==='0'){
        return '';
      }else{
        return 'success-row';
      }
    },
    /**
     * 初始化设备类型列表与配图
     * @returns {Promise<void>}
     */
    async initModelInfo() {
      this.modelTypeList = [];
      const data = await this.$api.modelType();
      if (data&&data.image){
        data.image.forEach(model=>{
          model.img = model.img.map(source=>'http://'+source);
          this.modelTypeList.push({modelType:model.name,modelImages:model.img});
        });
      }else {
        Message.error('加载设备类型列表失败！');
      }
    },
    ...mapMutations(['openAddModel'])
  },
  computed:{
    start(){//数据索引
      return (this.current-1)*this.limit;
    },
    tableData(){//限制传入的数据最多为limit条
      /*return this.data;//暂时不限制*/
      if(this.limit!==-1&&this.data.length>this.limit){
        return  this.data.filter((item,index)=>index<this.limit);
      }else {
        return this.data;
      }
    },

    label:{//主要作用：
      /**
       * 导入列设置的labelType属性设置，通过scoped参数返回0、1、2决定不同颜色标签的显示
       * @param columnSet 列设置
       */
      set(columnSet){
        columnSet.forEach((item,index)=>{//将列设置中标签设置导出到变量
          switch (item.labelType){
            case 'blue':
              this.label0.blue.push(index+'');//保存到对应颜色标签的数组
              break;
            case 'green':
              this.label0.green.push(index+'');
              break;
          }
        });
      },
      get(){
        let label0 =this.label0;
        return function(scope){//无标签返回0 ，蓝标签：1，绿标签：2
          let show = 0
          let key = scope.column.columnKey;
          if (label0.blue.some(i=>i===key)){//判断是否为某个颜色的标签
            show = 1;
          }else if (label0.green.some(i=>i===key)){
            show = 2;
          }
          return show;
        }
      }
    },

  },
  watch:{
  },
  created() {
    this.initModelInfo();
    this.label = this.columnSet;
  }
}
</script>

<style scoped>
  .my-table-box{
    max-height: 100% ;
  }
  .search{
    width: 220px;
    left: 40px;
    text-align: left;
    margin: 10px 20px 0 0;
  }
  .tableHead{
    height: fit-content;
    display: flex;
    align-items: center;
    width: 100%;
  }
  .topRight{
    position: relative;
    margin: 10px 40px 8px auto;
  }
  .topBtn{
    margin-right: 12px;
    background: transparent;
    border: none;
    color:#302ed2;
    font-size: 14px;
  }
  .offer:hover{
    color:#1c33b8;
  }
  .topBtn{
    margin-right: 12px;
    background: transparent;
    border: none;
    color:#302ed2;
    font-size: 14px;
  }

  .v-modal{
    z-index: -10000;
  }

</style>
